import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import CustomLinearProgress from '@src/new-components/LinearProgress';
import Typography from '@src/new-components/Typography';
import WrapperStepContent from '../WrapperStepContent';
import { StyledProcessingAudio } from './index.style';

const ProcessingAudio = ({ title, progress }) => {
  const { t } = useTranslation();

  return (
    <WrapperStepContent hideHeader>
      <StyledProcessingAudio>
        <div className="processing-audio-container">
          <Typography
            color={COLOR.descriptionUpload}
            variant="body-16-regular"
            sx={{
              marginBottom: '16px',
            }}
          >
            {t(title)}
          </Typography>
          <Typography color={COLOR.darkBlue} variant="body-16-bold">
            {progress}%
          </Typography>
        </div>
        <CustomLinearProgress
          variant="determinate"
          variantCustom="dark-blue"
          value={progress}
        />
      </StyledProcessingAudio>
    </WrapperStepContent>
  );
};

export default ProcessingAudio;
